var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { omit } from 'underscore';
export var userCommandGQL = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation userCommand($input: REST!) {\n    res(input: $input) @rest(type: \"user\", path: \"/userCommand\", method: \"POST\", endpoint: \"command\") {\n      id\n    }\n  }\n"], ["\n  mutation userCommand($input: REST!) {\n    res(input: $input) @rest(type: \"user\", path: \"/userCommand\", method: \"POST\", endpoint: \"command\") {\n      id\n    }\n  }\n"])));
export var userCommandMutation = function () { return ({
    mutation: userCommandGQL,
}); };
export var userCommandVariables = function (command) { return ({
    variables: {
        input: {
            type: command.type,
            payload: omit(command.payload, function (val) { return val === null || val === undefined; }),
        },
    },
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/userCommand.ts
// module id = 184
// module chunks = 81